import { render, staticRenderFns } from "./questionStep.vue?vue&type=template&id=68873427&scoped=true&"
import script from "./questionStep.vue?vue&type=script&lang=js&"
export * from "./questionStep.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./questionStep.vue?vue&type=style&index=0&id=68873427&prod&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "68873427",
  null
  ,true
)

export default component.exports